<app-menu-user-button-item (click)="openUserManagementService.openUserManagement()">
  <mat-icon icon>supervisor_account</mat-icon>
  <span label>Gestion des utilisateurs</span>
</app-menu-user-button-item>
